import React from 'react';
import Proptypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  NavigationItem,
  NavigationSection,
} from '@quintoandar/cozy-core/Navigation';
import WindowDialog from '@quintoandar/cozy-core/Dialog/WindowDialog';
import Box from '@quintoandar/cozy-core/Box';
import Button from '@quintoandar/cozy-core/Button';
import Divider from '@quintoandar/cozy-core/Divider';
import Typography from '@quintoandar/cozy-core/Typography';
import PersonIcon from '@quintoandar/cozy-icons/Person';
import KeyIcon from '@quintoandar/cozy-icons/Key';
import AccountCircleOutlineIcon from '@quintoandar/cozy-icons/AccountCircleOutline';
import CredentialsIcon from '@quintoandar/cozy-icons/Credentials';

import { isAgentRede } from 'containers/App/User/Data/useAgentData';
import {
  getOwnerPropertiesLink,
} from 'containers/Menu/MenuOld/urls';
import ROUTES from 'routes/constants';

import messages from './messages';
import { PROFILES } from './constants';
// TODO(DAG-1506): Remove MyAccountDialog folder when the new_menu_layout flag and MenuOld are removed.
const MyAccountDialog = ({ isOpen, onClose }) => {
  const intl = useIntl();

  const myDataUrl = ROUTES.PROFILE;

  const navigationItems = [
    {
      id: PROFILES.TENANT_BUYER,
      redirectUrl: ROUTES.SEARCH_CLIENTS,
      icon: PersonIcon,
      message: messages.tenantOrBuyer,
    },
    {
      id: PROFILES.OWNER,
      redirectUrl: getOwnerPropertiesLink(intl.locale),
      icon: KeyIcon,
      message: messages.owner,
    },
    {
      id: PROFILES.INDICA_AI,
      redirectUrl: '/indica-ai',
      icon: AccountCircleOutlineIcon,
      message: messages.indicaAi,
    },
    {
      id: PROFILES.ACCREDITED,
      redirectUrl: ROUTES.HOME,
      icon: CredentialsIcon,
      message: messages.accreditedAgent,
    },
  ];

  const filterByRole = (item) => {
    if (isAgentRede() && item.id === PROFILES.INDICA_AI) {
      return false;
    }

    return true;
  };

  const redirectToUrl = (url) => () => {
    window.location.replace(url);
  };

  return (
    <WindowDialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      onClose={onClose}
      title={intl.formatMessage(messages.dialogTitle)}
    >
      <Box>
        <Box ml={2}>
          <Typography level="bodyStrong">
            <FormattedMessage {...messages.changeProfile} />
          </Typography>
        </Box>
        <NavigationSection>
          {navigationItems
            .filter(filterByRole)
            .map(({ icon, message, redirectUrl }) => (
              <NavigationItem
                key={message}
                icon={icon}
                text={message}
                onClick={redirectToUrl(redirectUrl)}
              />
            ))}
        </NavigationSection>
        <Box mt={2} mx={2}>
          <Divider />
        </Box>
        <Box mb={2} mt={3} ml={2}>
          <Button variant="paddingless" onClick={redirectToUrl(myDataUrl)}>
            <FormattedMessage {...messages.dialogTitle} />
          </Button>
        </Box>
      </Box>
    </WindowDialog>
  );
};

MyAccountDialog.propTypes = {
  isOpen: Proptypes.bool,
  onClose: Proptypes.func,
};

export default MyAccountDialog;
